import React from "react";
import { Carousel } from "react-bootstrap";
import PostCard from "../cards/PostCard";

function PostSwiper({ data = [], getFeedsListingOnDelete, handleFeedEdit }) {
  console.log(data, "swiper data");
  return (
    <Carousel
      interval={null}
      pause={false}
      indicators={data.length > 1} // show bottom dots only if more than 1 slide
      controls={false} // hide arrows
      className="custom-blog-carousel custom-post-carousel"
    >
      {data.map((post, index) => (
        <Carousel.Item className="p-1" key={index}>
          {/* Ensure full width/height wrapper */}
          <PostCard
            getFeedsListingOnDelete={getFeedsListingOnDelete}
            handleFeedEdit={handleFeedEdit}
            post={post}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default PostSwiper;
